import { render, staticRenderFns } from "./HeaderMetanavigation.vue?vue&type=template&id=b0d78646&functional=true"
import script from "./HeaderMetanavigation.vue?vue&type=script&lang=js"
export * from "./HeaderMetanavigation.vue?vue&type=script&lang=js"
import style0 from "./HeaderMetanavigation.vue?vue&type=style&index=0&id=b0d78646&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports